export const STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in-progress',
  RESOLVED: 'resolved',
  REJECTED: 'rejected',
  SUSPENDED: 'suspended',
}

export const STATUS_MAPPINGS = {
  [STATUS.PENDING]: '待處理',
  [STATUS.IN_PROGRESS]: '處理中',
  [STATUS.RESOLVED]: '已解決',
  [STATUS.REJECTED]: '退卡',
  [STATUS.SUSPENDED]: '停話',
}

export const STATUS_OPTIONS = [
  {
    value: STATUS.PENDING,
    text: '待處理'
  },
  {
    value: STATUS.IN_PROGRESS,
    text: '處理中'
  },
  {
    value: STATUS.RESOLVED,
    text: '已解決'
  },
  {
    value: STATUS.REJECTED,
    text: '退卡'
  },
  {
    value: STATUS.SUSPENDED,
    text: '停話'
  },
]

export default {
  STATUS,
  STATUS_MAPPINGS,
  STATUS_OPTIONS,
}
